import { Outlet } from 'react-router-dom';
import { AuthContainer, FormContainer, FormContent, HorizontalLine } from './styles';
import Logo from "../../../assets/logos/logo-landscape.png";





function AuthPage() {
  return (
    <AuthContainer>
      <FormContainer className='mt-5 '>
        <img
          className="logo mx-4 mb-1"
          src={Logo}
          alt="logo"
          width="160"
        />
        <HorizontalLine />

        <FormContent>
          

          <Outlet />
        </FormContent>
      </FormContainer>
    </AuthContainer>
  );
}

export default AuthPage;